"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9502 10.0499c0 2.8996 1.4195 5.295 2.7532 6.9136C9.6687 18.1351 10.7955 19.0939 12 20c1.2084-.9085 2.3297-1.8628 3.2968-3.0365 1.3337-1.6186 2.7532-4.014 2.7532-6.9136C18.05 6.7086 15.3414 4 12.0001 4s-6.0499 2.7086-6.0499 6.0499zM12 12c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2z"
  })];
};

exports.default = _default;